export default __webpack_public_path__ + "static/media/apex-legends.19324ddc.png";